var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 10.8334C6.29357 10.8334 6.66667 11.2065 6.66667 11.6667V15C6.66667 15.4603 6.29357 15.8334 5.83333 15.8334C5.3731 15.8334 5 15.4603 5 15V11.6667C5 11.2065 5.3731 10.8334 5.83333 10.8334ZM10 4.16669C10.4602 4.16669 10.8333 4.53978 10.8333 5.00002V15C10.8333 15.4603 10.4602 15.8334 10 15.8334C9.53976 15.8334 9.16667 15.4603 9.16667 15V5.00002C9.16667 4.53978 9.53976 4.16669 10 4.16669ZM14.1667 7.50002C14.6269 7.50002 15 7.87312 15 8.33335V15C15 15.4603 14.6269 15.8334 14.1667 15.8334C13.7064 15.8334 13.3333 15.4603 13.3333 15V8.33335C13.3333 7.87312 13.7064 7.50002 14.1667 7.50002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analyticsIcon.c5c2ffcb.svg";
export { ForwardRef as ReactComponent };